module.exports = __webpack_public_path__ + "static/media/p_open.5847b67a.png";